import { ref, Ref } from 'vue'
import { Topic } from '@/model/data-object/Topic'
import useConfiguration from '@/composables/configuration/configuration'
import { StatusCodes, useFirstFromList } from '@/composables/api'
import useAppState from '@/composables/ui/ui'
import { TopicStatus } from '@/model/data-object/TopicSettings'
import AppError, { APP_ERRORS } from '@/error/appError'

const topic: Ref<Topic | undefined> = ref<Topic>()

export default function useTopic() {
  const { configuration } = useConfiguration()
  const { loadingTopic, appError } = useAppState()

  const loadTopic = async () => {
    const { request, response, statusCode } = useFirstFromList<Topic>(
      '/api/pub/v1/topic/ids/' + configuration.widget.topicId
    )
    loadingTopic.value = true
    await request()
    loadingTopic.value = false

    if (statusCode.value === StatusCodes.NOT_FOUND) {
      appError.value = new AppError(APP_ERRORS.TOPIC_OT_FOUND)

      return
    }

    if (response.value === null) {
      appError.value = new AppError(APP_ERRORS.TOPIC_OT_FOUND)

      return
    }

    if (response.value) {
      topic.value = response.value

      configuration.advertPositions = response.value.advertPositions
        .split(',')
        .map(position => parseInt(position))

      if (topic.value?.settings.status === TopicStatus.DELETED) {
        appError.value = new AppError(APP_ERRORS.TOPIC_OT_FOUND)
      }
    }
  }

  return {
    topic,
    loadTopic,
  }
}
